import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { DoLottery, GetLotteryHistory } from '../../common/actions/moreAction';
import { SetCurrentPage } from "../../common/actions/pageAction";
import { dateFormation, isEmpty } from "../../common/cores";
import Pagenation from "../common/Pagenation";


const LotteryContent = props => {
  const { page, user, history, leftCount } = props;
  const [ number, setNumber ] = useState(-1);
  const [ showResult, setShowResult ] = useState(true)

//   useEffect(() => {
//     infiniteScroll();
//   }, [])
    
  const getHistory = () => {
        props.GetLotteryHistory(page.curPage);
    }

    const getLottery = (all) => {
      if(showResult){
        setNumber("" );
        props.DoLottery(all)
        .then(result => {
          if (result.err) throw(result.err);
          if(result.success) {
                setShowResult(false);
                setNumber(result.bonus);
              }
            }).catch(err => {
          });
        }
    }

    useEffect(() => {
      getHistory()
    }, [page.curPage, page.perPage]);

    const onShowResult = () => {
      setShowResult(true);
      getHistory();
    }

    const onSetPage = (page) => {
      console.log('page.totalPage: ', page);
        props.SetCurrentPage({
            page: Number(page),
            totalPage: props.page.totalPage
        })
    }

  return (
    <Fragment>
      <div data-v-8a9c4d9d="" className="rightContent homePage lottery">
            <div data-v-8a9c4d9d="" className="contents">
                <div data-v-8a9c4d9d="" className="main_content_continer">
                    <div data-v-7f3aef84="" data-v-8a9c4d9d="" className="main-content padding-15">
                        <div data-v-7f3aef84="" className="aniFrame">
                            <div data-v-7f3aef84="" className="titlePic">
                                <div data-v-7f3aef84="" className="titlePwrapper">
                                    <div data-v-7f3aef84="" className="leftZone">
                                      <span className="Logo"></span>
                                      <span>&ensp;</span>
                                    </div>
                                    <div data-v-7f3aef84="" className="line m-d-none"></div>
                                </div>
                            </div>
                            <div data-v-7f3aef84="" className="main_content"> 
                                <div data-v-0838e822="" className = "main_content v_deep_deposit">
                                    <div data-v-0838e822="" className = "main_content_wrap main_content_wrap_notice deposit">
                                        <div data-v-0838e822="">
                                            <div data-v-0838e822="" className = "fundFrame noticeFrame">

                                              <div  data-v-0838e822="" className="d-flex m-d-block h-100">
                                                  <div className="w-50% m-w-100 d-flex h-100 lottery-min mb-40px">
                                                    <div className=" box_lottery ">
                                                      <div className="clip">
                                                        <span className="white-text">복권&nbsp;</span><span>{leftCount}개</span>
                                                      </div>
                                                      <div className="result">
                                                        {
                                                          showResult ? (number === -1 ? <span>아래 [복권 사용]을 클릭하세요.</span>
                                                              : 
                                                              <span className={`font-size-16 font-weight-400 ${ isEmpty(number) || number == 0 ? "red-color" : "green-color" }`}>
                                                                {isEmpty(number) || number == 0 ? "당첨이 없습니다." : "" + Number(number).toLocaleString() + "P가 당첨되였습니다."}
                                                              </span>)
                                                            : <Fragment>
                                                              <div className="d-flex align-items-center" onClick={onShowResult}>
                                                                <span>복권을 확인시려면 "클릭"해주세요</span>
                                                                <img src="../images/common/pointer.png" className="" alt=""/>
                                                              </div>
                                                            </Fragment>
                                                        }
                                                          
                                                      </div>
                                                      <div className="btn-group">
                                                        <div className="btn" onClick={() => getLottery(false)}>복권 사용</div>
                                                        <div className="btn" onClick={() => getLottery(true)}>전체 복권 사용</div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="w-50% m-w-100 lottery-history">
                                                      <div className = "listZone listZone01 noData pagenation">
                                                        <div className="con_box00 position-relative">
                                                          <table style={{width:"100%", borderSpacing: "0px"}}>
                                                              <tbody>
                                                                  <tr style={{borderBottom: "1px solid rgba(255, 255, 255, 0.1)"}}>
                                                                  <th className="list_title1" data-v-48a007d6="">번호</th>
                                                                  <th className="list_title1"  data-v-48a007d6="">사용일시</th>
                                                                  <th className="list_title1"  data-v-48a007d6="">당첨내역</th>
                                                                  </tr>
                                                                  {
                                                                    !isEmpty(history) && history.map((list, index) => {
                                                                        return (
                                                                            <tr data-v-48a007d6="" key={index}>
                                                                                <td className="list1" data-v-48a007d6="" style={{minWidth: "40px"}}>{isNaN(page.curPage) ? 0 : (page.curPage - 1) * 10 + index + 1}</td>
                                                                                <td className="list1"  data-v-48a007d6="">{dateFormation(list.used_date)}</td>
                                                                                <td className="list1"  data-v-48a007d6="">{!list.bonus ? "0" : Number(list.bonus.balance.rolling).toLocaleString()}P</td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                  }
                                                              </tbody>
                                                          </table>
                                                          {
                                                              history.length !== 0 ?
                                                              <Pagenation 
                                                                  
                                                                  page={page.curPage}
                                                                  totalPage={page.totalPage}
                                                                  getPage={onSetPage}
                                                                      />
                                                                  : ""
                                                          } 
                                                        </div>
                                                        
                                                      </div>
                                                      
                                                  </div>
                                                </div>
                                              </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        </div>
    </Fragment>
  );
};

const mapStateToProps = state => ({
  user: state.user,
  page: state.page,
  history: state.more.lottery.history,
  leftCount: state.more.lottery.leftCount
});

export default connect(
  mapStateToProps,
  { DoLottery, 
    GetLotteryHistory, 
    SetCurrentPage }
)(LotteryContent);



// WEBPACK FOOTER //
// ./src/components/account/LotteryContent.js